import React from 'react';
import { ArrowLeftIcon, BodyText, Col, Container, HeaderText, IconButton, Row } from 'shared-portal-component';
import '@/components/organism/SixDetail/Header/style.scss';

interface SixHeaderProps {
  orgName: string;
  filesCount: number;
  onBack: () => void;
}

const SixHeader: React.FC<SixHeaderProps> = ({ orgName, filesCount, onBack }) => (
  <Container fluid className="six-header">
    <Row spacing="md" align="center" justify="start">
      <Col size="content">
        <IconButton
          icon={<ArrowLeftIcon size="2x" />}
          ariaLabel="Back"
          size="lg"
          variant="secondary"
          onClick={onBack}
        />
      </Col>
      <Col size="content">
      <div>
        <HeaderText size='h1' text={orgName}  className="six-header__org"/>
         <BodyText as="p" className="six-header__files text-right">
        {filesCount} files
      </BodyText>
      </div>
      </Col>
    </Row>
    <Row spacing="none" align="center" justify="center">
      <Col size={12}>
        <hr className="six-header__divider" />
      </Col>
    </Row>
  </Container>
);

export default SixHeader;
